import { httpsCallable } from 'firebase/functions';
import { functions } from '.';

// the agreements a customer accepts when an account is created - the funnel, /sign-up and the guest support chat. the
// server keeps its own copy and never takes the list from a caller
export const ACCOUNT_AGREEMENT_KEYS = ['TERMS', 'PRIVACY', 'COMMUNICATION', 'TELEHEALTH_CONSENT', 'READYRX_PRIVACY_PRACTICES'];

// queues the customer's signed agreements when nothing has (account creation already does for the funnel and /sign-up),
// or, from staff, runs the customer's existing agreement job again (docs/EVENT_QUEUE.md). keys and signatureName are kept
// for positional callers but never sent: the server signs from the account itself
export const generateUserAgreements = async (userId, keys = [], ipAddress = null, signatureName = null, source = null) => {
    const func = httpsCallable(functions, 'generateuseragreements', { timeout: 70000 });
    const result = await func({ userId, ipAddress, source });
    return result?.data;
};
